import { STATS } from '../data/content';
import './Stats.css';

export default function Stats({ variant = 'light' }) {
  return (
    <section className={`dh-stats dh-stats--${variant}`} aria-label="Company statistics">
      <div className="dh-container dh-stats__grid">
        {STATS.map((stat) => (
          <div className="dh-stats__item" key={stat.label}>
            <strong>{stat.value}</strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
